import { render, staticRenderFns } from "./SignBill.vue?vue&type=template&id=652f4526&scoped=true"
import script from "./SignBill.vue?vue&type=script&lang=js"
export * from "./SignBill.vue?vue&type=script&lang=js"
import style0 from "./SignBill.vue?vue&type=style&index=0&id=652f4526&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652f4526",
  null
  
)

export default component.exports